import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import AutocompleteForms from "../AutocompleteForms";
import AutocompleteInputModule from "../AutoComplete";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
import EmptyTableRow from "../EmptyTableRow";
function Tribunal(props) {
  const { history } = props;
  const [TribunalStateUpdate, setTribunalStateUpdate] = useState([]);
  const [TribunalState, setTribunalState] = useState([]);
  const [tipoTribunal, setTipoTribunal] = useState([]);
  // const [rolTribunal, setRolTribunal] = useState([])
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  // eslint-disable-next-line
  useEffect(async () => {
    let response = await fetch(
      Parametros.urlApi + "courts?is_mantenedor=true",
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      let responseJson = await response.json();

      let responseJsonUpdate = JSON.stringify(responseJson);
      let responseJsonstate = JSON.stringify(responseJson);
      setTribunalState(JSON.parse(responseJsonUpdate));
      setTribunalStateUpdate(JSON.parse(responseJsonstate));
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }

    let responseTribunal = await fetch(
      Parametros.urlApi + "court_types?skip=0&limit=100",
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );

    if (responseTribunal.status === 200 || responseTribunal === 201) {
      let responseJsonTribunal = await responseTribunal.json();

      setTipoTribunal(responseJsonTribunal);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }

    // let responseRolTribunal = await fetch(Parametros.urlApi + "court_roles?skip=0&limit=100")
    // let responseJsonRolTribunal = await responseRolTribunal.json()
    //
    // setRolTribunal(responseJsonRolTribunal)
  }, [update, history, usuario]);
  const [formularioState, setFormularioState] = useState({
    name: "",
    type: "",
    // "role": ""
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    event.preventDefault();
    const value = event.target
      ? event.target.value
      : event.currentTarget.innerText;

    setFormularioState({
      ...formularioState,
      [event.target.name]: value,
    });
  };
  let crearTribunal = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        let newForm = formularioState;

        //
        let response = await fetch(Parametros.post + "court", {
          method: "POST",
          body: JSON.stringify(newForm),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          // let newArray = TribunalState
          // setTribunalState(JSON.parse(JSON.stringify(newArray)))
          // setTribunalStateUpdate(JSON.parse(JSON.stringify(newArray)))

          alert("se creo correctamente");

          document.getElementById("formularioBusqueda").reset();

          setFormularioState({
            name: "",
            type: "",
          });
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        setformularioUpdate({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let TribunalHandleChange = (index, e, setState, listaState, autocomplete) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = TribunalState;
    newList[index][name] = value;
    setTribunalState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi + "court/" + item.court_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert(responseJson.message);
          setUpdate(!update);
          setEditable({});
          setformularioUpdate({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setTribunalState(JSON.parse(JSON.stringify(TribunalStateUpdate)));
          setEditable({});
          setformularioUpdate({});
        }
      } else {
        // Do nothing!
        setEditable({});
        setformularioUpdate({});
        setTribunalState(JSON.parse(JSON.stringify(TribunalStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }

    // setetapaStateUpdate(nuevoObjeto)
  };

  let editar = (id) => {
    setTribunalState(JSON.parse(JSON.stringify(TribunalStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setformularioUpdate({});
    setEditable({});
    setTribunalState(JSON.parse(JSON.stringify(TribunalStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Tribunales"}></UserTab>
        <form id="formularioBusqueda">
          <div className="col-md-4">
            <h5>Nombre Tribunal</h5>
            <input
              onChange={handleStageForm}
              name="name"
              value={formularioState.name}
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Tipo de tribunal</h5>
            <AutocompleteForms
              personalHandleChange={handleStageForm}
              nameElement={"type"}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              key={update}
              required={true}
              value={formularioState.type}
              suggestions={tipoTribunal.map((item) => {
                return { value: item.court_type_id, label: item.name };
              })}
            />
          </div>

          {/* <div className='col-md-4'>
                        <h5>Rol de Tribunal</h5>
                        <AutocompleteForms nameElement={"role"} formularioBuscado={formularioState} setformulario={setFormularioState}
                            value={formularioState.role ? formularioState.role : ""} suggestions={rolTribunal.map((item) => { return item.name })} />
                    </div> */}

          <div className="col-md-4">
            <br />
            <button
              type="button"
              onClick={(e) => {
                crearTribunal(e);
              }}
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(TribunalState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Nombre Tribunal", "Tipo Tribunal"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={["Nombre Tribunal", "Tipo Tribunal"]}
            ></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {TribunalState.length === 0 && (
                  <EmptyTableRow colSpan={20} />
                )}
                {TribunalState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.court_id}>
                      {editable === item.court_id ? (
                        <>
                          <td>{item.court_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                TribunalHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>

                          <td>
                            <AutocompleteInputModule
                              suggestions={tipoTribunal.map((item) => {
                                return {
                                  value: item.court_type_id,
                                  label: item.name,
                                };
                              })}
                              i={index}
                              value={item.type}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setTribunalState}
                              state={TribunalState}
                              name={"type"}
                            ></AutocompleteInputModule>
                          </td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.court_id}</td>
                          <td>{item.name} </td>
                          <td>{item.type_name} </td>
                          <td>
                            <abbr title="Editar Elemento ">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.court_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`court/${item.court_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />{" "}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(TribunalState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Tribunal);
